exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.crop-img-modal .cropper-container{\n    margin: auto;\n}\n.ih-box{\n}\n", ""]);

// exports
